/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.userRegistrationWithCrm.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class ExternalProducts(
    @SerialName("integration_id")
    val integrationId: Int?,

    @SerialName("id")
    val id: String?,

    @SerialName("type")
    val type: String?,

    @SerialName("title")
    val title: String?,

    @SerialName("url")
    val url: String?,

    @SerialName("variations")
    val variations: ExternalProductsVariations?,

    @SerialName("properties")
    val properties: List<ExternalProductProperty>?,

    @SerialName("images")
    val images: List<ExternalProductImage>?,

    @SerialName("price")
    val price: Float?,

    @SerialName("points")
    val points: Int?
)
